module.exports = __webpack_public_path__ + "static/assets/d96fb43b5556759fae6433eecb5215cd.png";